import { render, staticRenderFns } from "./AIRecommendationsContent.vue?vue&type=template&id=24ff7643&scoped=true&"
import script from "./AIRecommendationsContent.vue?vue&type=script&lang=js&"
export * from "./AIRecommendationsContent.vue?vue&type=script&lang=js&"
import style0 from "./AIRecommendationsContent.vue?vue&type=style&index=0&id=24ff7643&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ff7643",
  null
  
)

export default component.exports